import { lazy } from 'react';

export const DashboardPage = lazy(() => import('./dashboard-page'));
